import { actionsTypes as types } from "../actions/uiActions";

const INITIAL_STATE_DRAG = {
  active: false,
  originx: -5,
  originy: -5
};

const INITIAL_STATE = {
  deviceSettingsOpen: false,
  widgetSettingsOpen: false,
  drag: INITIAL_STATE_DRAG,
  showWidgetBar: true,
  showDeviceBar: true,
  hoveredWidget: false,
  detectedQuerx: false,
  mobileQRWindowOpen: false
};

const uiReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case types.TOGGLE_MOBILE_QR_SETTINGS:{
      return {
        ...state,
        mobileQRWindowOpen: !!!state.mobileQRWindowOpen
      }
    }

    case types.TOGGLE_DEVICE_SETTINGS:
      let newVal;
      if (state.deviceSettingsOpen === false) {
        newVal = { deviceUid: action.uid, sensorKey: action.sensorKey };
      } else {
        newVal = false;
      }
      return {
        ...state,
        deviceSettingsOpen: newVal
      };

    case types.HIDE_DEVICE_SETTINGS:
      return {
        ...state,
        deviceSettingsOpen: false
      };

    case types.TOGGLE_WIDGET_SETTINGS:
      var _newVal;
      if (state.widgetSettingsOpen === false) {
        _newVal = { widgetid: action.widgetid };
      } else {
        _newVal = false;
      }
      return {
        ...state,
        widgetSettingsOpen: _newVal
      };

    case types.SWITCH_TO_TAB: {
      console.log("SWITCH_TO_TAB in reducer", action);

      let newVal = state.deviceSettingsOpen;
      if (state.deviceSettingsOpen === false) {
        return state;
      } else {
        newVal = { deviceUid: action.uid, sensorKey: action.sensorKey };
      }
      return {
        ...state,
        deviceSettingsOpen: newVal
      };
    }

    case types.START_DRAG:
      console.log("start drag in REDUCER");
      let { originx, originy, source } = action;
      return {
        ...state,
        drag: {
          active: true,
          originx,
          originy,
          source
        }
      };

    case types.CANCEL_DRAG:
      console.log("start drag in REDUCER");
      return {
        ...state,
        drag: {
          active: false,
          originx: -5,
          originy: -5
        }
      };

    case types.SET_HOVERED_WIDGET:
      return {
        ...state,
        hoveredWidget: action.widgetid
      };

    case types.SET_HOVERED_SENSOR:
      if (action.deviceid === false || action.sensorid === false) {
        return {
          ...state,
          hoveredSensor: false
        };
      }
      return {
        ...state,
        hoveredSensor: { deviceid: action.deviceid, sensorid: action.sensorid }
      };

    case types.SET_DETECTED_QUERX: {
      console.log("SET_DETECTED_QUERX reducer called", action);
      return {
        ...state,
        detectedQuerx: {
          qname: action.qname,
          device_id: action.device_id,
          template_val: action.template_val
        }
      };
    }

    case types.RESET_DETECTED_QUERX: {
      return {
        ...state,
        detectedQuerx: false
      };
    }

    default:
      return state;
  }
};

export default uiReducer;
